export default __webpack_public_path__ + "static/media/heartIcon.55ac2e84.svg";